export default "__VITE_ASSET__X$ug1308__";